import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { Picking } from "interfaces/picking";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_PICKING_QUARENTINES_" }
);

export interface ListPickingQuarentinesState extends IState {
  data: Picking[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: Picking[];
}

const INITIAL_STATE: ListPickingQuarentinesState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListPickingQuarentinesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListPickingQuarentinesState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListPickingQuarentinesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listPickingQuarentines = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListPickingQuarentinesTypes = Types;
export const ListPickingQuarentinesActions = Creators;
